<!--{{visitAddFacade.user() | json}}-->
@let user = visitAddFacade.user();
<div class="h-full w-full pb-20 lg:pb-16" data-testid="visit-drawer">
  <div class=" p-2">
    <nz-tabset
      style="height: 100%;"
      [nzTabPosition]="nzTabPosition"
      [(nzSelectedIndex)]="selectedIndex"
    >
      @if (!visitAddFacade.visitId) {

        <nz-tab
          [nzTitle]="visitTitle"
        >
          <ng-template #visitTitle let-visible="visible">
            <div class="px-3 py-0 pt-2  w-[220px] flex gap-2">
              <div>
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </div>
              <div>ვიზიტის ინფორმაცია</div>
            </div>
          </ng-template>
          <beautyapp-visit-add-booking (getVisit)="getVisit($event)"
                                       [bookingDate]="data.date"
                                       [employeeId]="data.employeeId"
                                       [roomId]="data.roomId"
                                       [checkPendingOverlap]="data.checkPendingOverlap"
          />
        </nz-tab>
      } @else {
        <nz-tab
          [nzTitle]="serviceTitle"
          [nzDisabled]="visitAddFacade.checkDisableStatus('services', 1)"
        >
          <ng-template #serviceTitle let-visible="visible">
            <div class="px-3 py-0 pt-2 w-[220px] flex gap-2">
              <nz-badge [nzCount]="visitAddFacade.bookings().length || 0">
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </nz-badge>
              <div>
                ვიზიტის ინფორმაცია
              </div>
            </div>
          </ng-template>

          <div class="flex flex-col gap-3 pr-2 pl-2 lg:pr-6 lg:pl-0 pt-4 pb-6" [formGroup]="form">
            @if (visitAddFacade.userId) {
              <beautyapp-user-card
                [user]="user"
                (viewUser)="visitAddFacade.viewUser($event)"
                (verifyUser)="visitAddFacade.verify($event)"
                (refreshVisitEvent)="getVisit($event)"
              ></beautyapp-user-card>
            }

            <!-- beaut-545. In a card, like the customer block above it. Loose on
                 the page background this strip lined up with nothing: the visit's
                 "when" reads as part of the page chrome rather than as the second
                 fact about the visit. Labels sit above their values here, the way
                 they do everywhere else on this screen. -->
            <nz-card>
              <div class="visit-when">
                <div class="visit-when__field">
                  <span class="visit-when__label">თარიღი</span>
                  <div class="visit-when__value">
                    <span>{{ visitDate() | date: 'dd.MM.yyyy' }}</span>
                    <nz-divider nzType="vertical"></nz-divider>
                    <span>
                      {{ visitAddFacade.visit()?.startTime | slice:0:5 }}
                      - {{ visitAddFacade.visit()?.endTime | slice:0:5 }}
                    </span>
                  </div>
                </div>

                <div class="visit-when__field visit-when__field--source">
                  <span class="visit-when__label">{{ 'calendar.form.source' | translate }}</span>
                  @if (!editingSource()) {
                    <div class="visit-when__value">
                      @if (visitAddFacade.visit()?.source) {
                        @if (isEmoji(visitAddFacade.visit()?.source?.icon)) {
                          <span class="text-xl">{{ visitAddFacade.visit()?.source?.icon }}</span>
                        } @else if (visitAddFacade.visit()?.source?.icon) {
                          <span nz-icon [nzType]="visitAddFacade.visit()?.source?.icon" nzTheme="outline"></span>
                        }
                        <span>{{ visitAddFacade.visit()?.source?.name }}</span>
                      } @else {
                        <span class="visit-when__empty">-</span>
                      }
                      @if (!visitAddFacade.isCompleted) {
                        <button
                          nz-button
                          nzType="link"
                          nzSize="small"
                          (click)="startEditingSource()"
                          *ngxPermissionsOnly="['Admin']"
                        >
                          <span nz-icon nzType="edit" nzTheme="outline"></span>
                        </button>
                      }
                    </div>
                  } @else {
                    <div class="visit-when__value visit-when__value--editing">
                      <nz-select
                        [ngModel]="selectedSourceId()"
                        (ngModelChange)="onSourceChange($event)"
                        [nzPlaceHolder]="'calendar.form.sourcePlaceholder' | translate"
                        nzAllowClear
                        [nzDisabled]="updatingSource()"
                        [ngModelOptions]="{standalone: true}"
                      >
                        @for (source of bookingSources(); track source.id) {
                          <nz-option [nzValue]="source.id" [nzLabel]="source.name"></nz-option>
                        }
                      </nz-select>
                      <button
                        nz-button
                        nzType="primary"
                        nzSize="small"
                        (click)="updateVisitSource()"
                        [nzLoading]="updatingSource()"
                        [disabled]="updatingSource()"
                      >
                        <span nz-icon nzType="check" nzTheme="outline"></span>
                      </button>
                      <button
                        nz-button
                        nzType="default"
                        nzSize="small"
                        (click)="cancelEditingSource()"
                        [disabled]="updatingSource()"
                      >
                        <span nz-icon nzType="close" nzTheme="outline"></span>
                      </button>
                    </div>
                  }
                </div>
              </div>
            </nz-card>


            <beautyapp-booking-list [visitId]="visitAddFacade.visit()?.id" [reloadCount]="bookingListReloadCount()" (getVisit)="getVisit($event)" />

            <!--            <div class="flex justify-between items-center gap-3">-->
            <!--              <beautyapp-textarea-->
            <!--                formControlName="description"-->
            <!--                placeholder=""-->
            <!--                label="{{ 'calendar.form.comment' | translate }}"-->
            <!--                [rows]="5"-->
            <!--                [disabled]="visitAddFacade.isCompleted"-->
            <!--              ></beautyapp-textarea>-->
            <!--            </div>-->
            <!--            <div class="flex justify-between items-center gap-3">-->
            <!--              <label-->
            <!--                nz-checkbox-->
            <!--                formControlName="sendNotification"-->
            <!--                style="margin-bottom: 10px"-->
            <!--                [nzDisabled]="visitAddFacade.isCompleted"-->
            <!--              >{{ 'addVisit.form.sendNotification' | translate }}</label>-->
            <!--            </div>-->

            <div class="flex justify-between items-center gap-3">
              <div class="flex justify-between items-center gap-3">
                @if (visitAddFacade.visitId) {
                  <button
                    nz-button
                    nzType="default"
                    nzSize="large"
                    [nzDanger]="true"
                    (click)="cancel()"
                    [disabled]="visitAddFacade.isCompleted"
                  >
                    {{ 'addVisit.buttons.cancel' | translate }}
                  </button>
                }
              </div>

              <div class="flex justify-end items-center gap-3">
                <button
                  nz-button
                  nzType="default"
                  nzSize="large"
                  (click)="drawerRef.close()"
                >
                  {{ 'addVisit.buttons.close' | translate }}
                </button>

                <!--                <button-->
                <!--                  nz-button-->
                <!--                  nzType="primary"-->
                <!--                  nzSize="large"-->
                <!--                  (click)="addVisit()"-->
                <!--                  [nzLoading]="visitAddFacade.loading()"-->
                <!--                  [disabled]="visitAddFacade.isCompleted"-->
                <!--                >-->
                <!--                  {{ 'addVisit.buttons.saveVisit' | translate }}-->
                <!--                </button>-->


              </div>
            </div>
          </div>
        </nz-tab>
      }
      <nz-tab
        [nzTitle]="realizationTitle"
        [nzDisabled]="visitAddFacade.checkDisableStatus('realization', 1)"
      >
        <ng-template #realizationTitle let-visible="visible">
          <div class="px-3 py-0 w-[220px] flex gap-2">
            <nz-badge [nzCount]="visitAddFacade.realizations().length || 0">
              <span nz-icon nzType="shopping-cart" nzTheme="outline"></span>
            </nz-badge>
            <div>
              პროდუქცია
            </div>
          </div>
        </ng-template>
        <div class="flex flex-col gap-3 pr-2 pl-2 lg:pr-6 lg:pl-0 pt-4 pb-6">
          @if (visitAddFacade.userId) {
            <beautyapp-user-card
              [user]="user"
              (viewUser)="visitAddFacade.viewUser($event)"
              (verifyUser)="visitAddFacade.verify($event)"
              (refreshVisitEvent)="getVisit($event)"
            ></beautyapp-user-card>
          }
          @if (+visitAddFacade.visitId) {
            <beautyapp-realization-list [visitId]="visitAddFacade.visit()?.id" (getVisit)="getVisit()" />
          }
        </div>
      </nz-tab>
      @if (ehrActive()) {
        <nz-tab
          [nzTitle]="ehrTitle"
          [nzDisabled]="visitAddFacade.checkDisableStatus('ehr', 1)"
        >
          <ng-template #ehrTitle let-visible="visible">
            <div class="px-3 py-0 w-[220px] flex gap-2">
              <nz-badge [nzCount]="visitAddFacade.ehrs().length">
                <span nz-icon nzType="medicine-box" nzTheme="outline"></span>
              </nz-badge>
              <div>
                EHR
              </div>
            </div>
          </ng-template>
          <div class=" pr-2 pl-2 lg:pr-6 lg:pl-0 pt-4 pb-6 flex flex-col gap-3">
            @if (visitAddFacade.userId) {
              <beautyapp-user-card
                [user]="user"
                (viewUser)="visitAddFacade.viewUser($event)"
                (verifyUser)="visitAddFacade.verify($event)"
                (refreshVisitEvent)="getVisit($event)"
              ></beautyapp-user-card>
            }

            @if (+visitAddFacade.visitId) {
              <beautyapp-ehr-list [visitId]="+visitAddFacade.visitId" [reload]="ehrReload()" />
            }

          </div>

        </nz-tab>
      }
      @if (showPayment()) {
      <nz-tab
        [nzTitle]="paymentTitle"
        [nzDisabled]="visitAddFacade.checkDisableStatus('payment', 1)"
      >
        <ng-template #paymentTitle let-visible="visible">
          <div class="px-3 py-0 w-[220px] flex gap-2">
            <div>
              <span nz-icon nzType="audit" nzTheme="outline"></span>
            </div>
            <div>გადახდა</div>
          </div>
        </ng-template>
        <div class="w-full pr-2 pl-2 lg:pr-6 lg:pl-0 pt-4 pb-6">
          @if (visitAddFacade.userId) {
            <beautyapp-user-card
              [user]="user"
              (viewUser)="visitAddFacade.viewUser($event)"
              (verifyUser)="visitAddFacade.verify($event)"
              (refreshVisitEvent)="getVisit($event)"
            ></beautyapp-user-card>
          }
          <div class="flex flex-col gap-2  ">
            <div class="flex justify-between items-center">
              <h1 class="text-xl font-bold text-gray-800">
                პროცედურები
              </h1>
            </div>
            @for (booking of visitAddFacade.bookings(); track $index; let last = $last) {
              <div class="flex flex-col gap-2 w-full border border-gray-200 py-2 px-4 rounded-md">
                <div class="flex justify-between gap-3 w-full border-b border-gray-200 py-2">
                  <div class="text-lg">{{ booking?.employee?.user?.fullName }}</div>
                  <div class="flex gap-3 items-center">
                    <div><i nz-icon nzType="field-time" nzTheme="outline" style="color: #FF3FB4"></i>
                      {{ booking.startTime }} - {{ booking.endTime }}
                    </div>
                  </div>
                </div>

                @for (bookingService of booking.bookingServices; track $index; let last = $last) {
                  <div class="flex justify-between gap-3 w-full py-2"
                       [class.border-b]="!last && booking.bookingServices.length > 1"
                       [class.border-gray-100]="!last && booking.bookingServices.length > 1">
                    <div>
                      <div class="text-lg">{{ bookingService?.service?.name }}</div>
                      @if (bookingService?.offerPurchaseId) {
                        <nz-tag nzColor="gold" class="text-xs">
                          <i nz-icon nzType="gift" nzTheme="outline"></i>
                          შეთავაზება
                        </nz-tag>
                      }
                      @if (bookingService?.packagePurchaseId) {
                        <nz-tag nzColor="cyan" class="text-xs">
                          <i nz-icon nzType="gift" nzTheme="outline"></i>
                          პაკეტი
                        </nz-tag>
                      }
                      @if (bookingService?.packageExpired) {
                        <nz-tag nzColor="error" class="text-xs">
                          <i nz-icon nzType="warning" nzTheme="outline"></i>
                          {{ 'calendar.packageExpired' | translate }}
                          @if (bookingService?.validUntil) {
                            ({{ bookingService.validUntil | date: 'yyyy-MM-dd' }})
                          }
                        </nz-tag>
                      }
                      <div class="flex gap-3 items-center">
                        <!--
                          beaut-240: show the procedure's TOTAL cost. Showing
                          `expence` alone left the fixed sum invisible here while
                          the grand total below (visitAddFacade.totalExpense())
                          included it, so the rows never added up to the total.
                        -->
                        @if (+(bookingService?.expence || 0) + +(bookingService?.additionalExpence || 0); as rowExpense) {
                          <div class="flex gap-1 items-center">
                            <i nz-icon nzType="dollar" nzTheme="outline" style="color: #FF3FB4"></i>
                            <div>დანახარჯი</div>
                            <div>{{ rowExpense }} <i class="lari lari-c"></i></div>
                          </div>
                        }
                      </div>
                    </div>
                    <div>
                      <div class="flex gap-1 items-center">
                        @if (bookingService?.salePrice > 0) {
                          <div class="flex flex-col items-center gap-1">
                            <div>
                              {{ bookingService?.salePrice }} <i class="lari lari-c"></i>
                            </div>
                            <del>{{ bookingService?.price }} <i class="lari lari-c"></i></del>
                          </div>
                        }
                        @if (bookingService?.salePrice <= 0) {
                          <div>
                            {{ bookingService?.price }} <i class="lari lari-c"></i>
                          </div>
                        }
                      </div>
                      <div>
                        @if (bookingService?.service?.serviceType === 'MINUTE') {
                          <div>
                            <i nz-icon nzType="clock-circle" nzTheme="outline" style="color: #FF3FB4"></i>
                            {{ bookingService?.minutes }} წთ
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <div class="flex justify-between gap-3 py-2">
            <div>
              <div>
                ჯამში დანახარჯი: {{ visitAddFacade.totalExpense() || 0 }} <i class="lari lari-c"></i>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <div>ჯამში: {{ visitAddFacade.totalPrice() }} <i class="lari lari-c"></i></div>
              @if (visitAddFacade.totalMinutesPrice() > 0) {
                <div>წუთები: {{ visitAddFacade.totalMinutes() }} წთ; ფასი: {{ visitAddFacade.totalMinutesPrice() }} <i
                  class="lari lari-c"></i></div>
              }
            </div>
          </div>
          <nz-divider />
          @if (visitAddFacade.realizations().length) {
            <div class="flex flex-col gap-3 py-2">
              <div class="flex justify-between items-center">
                <h1 class="text-xl font-bold text-gray-800">
                  პროდუქცია
                </h1>
              </div>

              @for (realization of visitAddFacade.realizations(); track realization; let last = $last) {
                <div class="flex justify-between gap-3 w-full py-2"
                     [class.border-b]="!last && visitAddFacade.realizations().length > 1"
                     [class.border-gray-200]="!last && visitAddFacade.realizations().length > 1">
                  <div>
                    <div class="text-lg">{{ realization?.product.name }}</div>
                  </div>
                  <div>
                    <div class="flex gap-1 items-center">
                      @if (realization.discountPrice > 0) {
                        <div class="flex flex-col items-center gap-1">
                          <div>
                            {{ realization.discountPrice }} <i class="lari lari-c"></i>
                          </div>
                          <del>{{ realization.price }} <i class="lari lari-c"></i></del>
                        </div>
                      }
                      @if (realization.discountPrice <= 0) {
                        <div>
                          {{ realization.price }} <i class="lari lari-c"></i>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="flex justify-end gap-3 py-2">
              <div class="flex flex-col gap-2">
                <div>ჯამში: {{ visitAddFacade.totalRealizationPrice() }} <i class="lari lari-c"></i></div>
              </div>
            </div>
            <nz-divider />
          }

          <div class="flex flex-col gap-3 py-2">
            <div class="flex justify-between gap-3 w-full border-b border-gray-200 py-2">
              <div>
                ჯამში გადასახდელი თანხა:
              </div>
              <div>
                {{ visitAddFacade.totalPayPrice() }} <i class="lari lari-c"></i>
              </div>
            </div>
            @if (visitAddFacade.totalMinutes() > 0) {
              <div class="flex justify-between gap-3 w-full border-b border-gray-200 py-2">
                <div>
                  ჯამში გადასახდელი წუთები:
                </div>
                <div>
                  {{ visitAddFacade.totalMinutes() }} წთ
                </div>
              </div>
            }
          </div>

          <!-- ==================== PAYMENT SUMMARY CARD ==================== -->
          <div class="payment-summary-card">
            <div class="summary-header">
              <span nz-icon nzType="wallet" nzTheme="outline"></span>
              <span>გადახდის შეჯამება</span>
            </div>
            <div class="summary-rows">
              <div class="summary-row">
                <span>პროცედურები:</span>
                <span>{{ visitAddFacade.totalPrice() }} <i class="lari lari-c"></i></span>
              </div>
              @if (visitAddFacade.realizations().length) {
                <div class="summary-row">
                  <span>პროდუქცია:</span>
                  <span>{{ visitAddFacade.totalRealizationPrice() }} <i class="lari lari-c"></i></span>
                </div>
              }
              @if (visitAddFacade.totalMinutes() > 0) {
                <div class="summary-row">
                  <span>წუთები:</span>
                  <span>{{ visitAddFacade.totalMinutes() }} წთ</span>
                </div>
              }
              <div class="summary-row total">
                <span>სულ გადასახდელი:</span>
                <span>{{ visitAddFacade.totalPayPrice() }} <i class="lari lari-c"></i></span>
              </div>
              @if (visitAddFacade.visitPayments().length > 0) {
                @if (visitAddFacade.totalPayPrice() > 0) {
                  <div class="summary-row paid">
                    <span>გადახდილი:</span>
                    <span>{{ visitAddFacade.totalPaid() }} <i class="lari lari-c"></i></span>
                  </div>
                  @if (visitAddFacade.totalConsignation() > 0) {
                    <div class="summary-row" style="color: #fa541c;">
                      <span>კონსიგნაცია (დავალიანება):</span>
                      <span>{{ visitAddFacade.totalConsignation() }} <i class="lari lari-c"></i></span>
                    </div>
                  }
                  <div class="summary-row remaining">
                    <span>დარჩენილი:</span>
                    <span>{{ visitAddFacade.remainingAmount() }} <i class="lari lari-c"></i></span>
                  </div>
                }
                @if (visitAddFacade.totalMinutes() > 0) {
                  <div class="summary-row paid">
                    <span>გადახდილი წუთები:</span>
                    <span>{{ visitAddFacade.totalMinutesPaid() }} წთ</span>
                  </div>
                  <div class="summary-row remaining">
                    <span>დარჩენილი წუთები:</span>
                    <span>{{ visitAddFacade.remainingMinutes() }} წთ</span>
                  </div>
                }
              }
            </div>
          </div>

          <!-- ==================== PAYMENT HISTORY ==================== -->
          @if (visitAddFacade.visitPayments().length > 0) {
            <div class="payment-history-section">
              <div class="section-header">
                <span nz-icon nzType="history" nzTheme="outline"></span>
                <span>გადახდის ისტორია</span>
              </div>
              @for (payment of visitAddFacade.visitPayments(); track payment.id) {
                <div class="payment-history-item">
                  <div class="payment-info">
                    <div class="payment-info-top">
                      <nz-tag [nzColor]="'blue'">{{ payment.paymentType | paymentType | translate }}</nz-tag>
                      @if (payment.description?.includes('BookingHub')) {
                        <nz-tag nzColor="purple">
                          <span nz-icon nzType="global" nzTheme="outline"></span>
                          BookingHub
                        </nz-tag>
                      }
                      <span class="payment-date">{{ payment.transactionDate | date:'dd.MM.yyyy HH:mm' }}</span>
                    </div>
                    @if (payment.createdBy?.fullName) {
                      <span class="payment-created-by">
                        <span nz-icon nzType="user" nzTheme="outline"></span>
                        {{ payment.createdBy.fullName }}
                      </span>
                    }
                  </div>
                  <div class="payment-amount-actions">
                    <div class="payment-amounts">
                      @if (payment.minutes > 0) {
                        <span class="payment-amount minutes">{{ payment.minutes }} წთ</span>
                      }
                      @if (+payment.paymentType === 7 && payment.price > 0) {
                        <div class="flex flex-col items-end gap-1">
                          <div class="flex gap-2">
                            @if (+payment.cash > 0) {
                              <span style="font-size: 13px;">ნაღდი: {{ payment.cash }} <i class="lari lari-c"></i></span>
                            }
                            @if (+payment.card > 0) {
                              <span style="font-size: 13px;">ბარათი{{ payment.bankId ? ' (' + payment.bankId + ')' : '' }}: {{ payment.card }} <i class="lari lari-c"></i></span>
                            }
                            @if (+payment.bank > 0) {
                              <span style="font-size: 13px;">საბანკო: {{ payment.bank }} <i class="lari lari-c"></i></span>
                            }
                            @if (+payment.balance > 0) {
                              <span style="font-size: 13px;">ბალანსი: {{ payment.balance }} <i class="lari lari-c"></i></span>
                            }
                          </div>
                          <span class="payment-amount" style="color: #fa541c; font-size: 13px;">კონს: {{ (+payment.price || 0) - (+payment.cash || 0) - (+payment.card || 0) - (+payment.bank || 0) - (+payment.balance || 0) }} <i class="lari lari-c"></i></span>
                        </div>
                      } @else if (payment.price > 0) {
                        <span class="payment-amount">{{ payment.price }} <i class="lari lari-c"></i></span>
                      }
                      @if (!payment.minutes && !payment.price) {
                        <span class="payment-amount">0 <i class="lari lari-c"></i></span>
                      }
                    </div>
                    @if (!visitAddFacade.isCompleted) {
                      <button nz-button nzType="text" nzDanger nzSize="small"
                              nz-popconfirm nzPopconfirmTitle="გადახდის წაშლა?"
                              (nzOnConfirm)="deletePayment(payment.id)">
                        <span nz-icon nzType="delete"></span>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          }

          <!-- ==================== PAYMENT FORM (not completed & remaining > 0 or remaining minutes > 0) ==================== -->
          @if (visitAddFacade.visit()?.status !== 'COMPLETED' && (visitAddFacade.remainingAmount() > 0 || visitAddFacade.remainingMinutes() > 0 || visitAddFacade.isZeroTotal())) {
            <div [formGroup]="paymentForm" class="flex flex-col gap-3 py-2">
              <div>
                @if (visitAddFacade.totalMinutes() > 0) {
                  <div class="w-1/2">
                    <beautyapp-input
                      label="{{ 'calendar.form.minutes' | translate }}"
                      placeholder="{{ 'calendar.form.minutes' | translate }}"
                      type="number"
                      prefixIcon="tags"
                      formControlName="minutes"
                      [max]="+visitAddFacade.totalMinutes() || 0"
                      size="large"
                      [errors]="{
                        max: 'არ შეიძლება მეტი იყოს ვიზიტში გადასახდელი წუთების ჯამზე მეტი'
                      }"
                    ></beautyapp-input>
                    <div>
                      <nz-tag [nzColor]="'#01beff'">
                        {{ 'calendar.form.available' | translate }}
                        : {{ user.minutes || 0 }}
                        {{ 'calendar.minute' | translate }}
                      </nz-tag>
                    </div>
                  </div>
                }
              </div>
              <div class="w-1/2">
                <beautyapp-select
                  label="{{ 'calendar.form.paymentMethod' | translate }}"
                  placeholder="{{ 'calendar.form.paymentMethod' | translate }}"
                  formControlName="paymentType"
                  [data]="visitAddFacade.isZeroTotal() ? visitAddFacade.zeroTotalPaymentTypes : visitAddFacade.regularPaymentTypes"
                  valueMember="id"
                  displayMember="name"
                  size="large"
                ></beautyapp-select>
              </div>

              @if (visitAddFacade.paymentType) {
                @if (visitAddFacade.paymentType === 1 || visitAddFacade.paymentType === 9 || visitAddFacade.paymentType === 7) {
                  <div class="w-1/2">
                    <beautyapp-input
                      label="{{ 'calendar.form.cash' | translate }}"
                      placeholder="{{ 'calendar.form.cash' | translate }}"
                      type="number"
                      prefixIcon="wallet"
                      formControlName="cash"
                      size="large"
                    ></beautyapp-input>
                  </div>
                }

                @if (visitAddFacade.paymentType === 2 || visitAddFacade.paymentType === 9 || visitAddFacade.paymentType === 7) {
                  <div class="w-full flex gap-3">
                    <beautyapp-input
                      label="{{ 'calendar.form.bank' | translate }}"
                      placeholder="{{ 'calendar.form.bank' | translate }}"
                      type="number"
                      prefixIcon="credit-card"
                      formControlName="card"
                      size="large"
                    ></beautyapp-input>
                    <beautyapp-select
                      label="{{ 'calendar.form.paymentMethod' | translate }}"
                      placeholder="{{ 'calendar.form.paymentMethod' | translate }}"
                      formControlName="bank"
                      [data]="visitAddFacade.banks"
                      valueMember="id"
                      displayMember="name"
                      size="large"
                    ></beautyapp-select>
                  </div>
                }

                @if (visitAddFacade.paymentType === 9 || visitAddFacade.paymentType === 5) {
                  <div class="w-1/2">
                    <beautyapp-input
                      label="{{ 'calendar.form.balance' | translate }}"
                      placeholder="{{ 'calendar.form.balance' | translate }}"
                      type="number"
                      prefixIcon="tags"
                      formControlName="balance"
                      [max]="user.balance || 0"
                      size="large"
                    ></beautyapp-input>
                    <div>
                      <nz-tag [nzColor]="'#00cf72'">
                        {{ 'calendar.form.available' | translate }}:
                        {{ (user.balance || 0) | number: '1.0-2' }} <i class="lari lari-c"></i>
                      </nz-tag>
                    </div>
                  </div>
                }

                @if (visitAddFacade.paymentType === 7) {
                  <div class="w-1/2">
                    <beautyapp-input
                      label="{{ 'calendar.form.consignment' | translate }}"
                      placeholder="{{ 'calendar.form.consignment' | translate }}"
                      type="number"
                      prefixIcon="tags"
                      formControlName="consignation"
                      size="large"
                    ></beautyapp-input>
                  </div>
                }

                @if (visitAddFacade.paymentType === 8 || visitAddFacade.paymentType === 9) {
                  <div class="w-full flex gap-3">
                    <beautyapp-input
                      label="{{ 'calendar.form.bankTransfer' | translate }}"
                      placeholder="{{ 'calendar.form.bankTransfer' | translate }}"
                      type="number"
                      prefixIcon="tags"
                      formControlName="bankTransfer"
                      size="large"
                    ></beautyapp-input>
                    <beautyapp-select
                      label="{{ 'calendar.form.paymentMethod' | translate }}"
                      placeholder="{{ 'calendar.form.paymentMethod' | translate }}"
                      formControlName="bankTransferBank"
                      [data]="visitAddFacade.banks"
                      valueMember="id"
                      displayMember="name"
                      size="large"
                    ></beautyapp-select>
                  </div>
                }
              }
            </div>
            <div class="payment-actions">
              @if (visitAddFacade.paymentType === 6 || visitAddFacade.paymentType === 11) {
                <!-- Barter (6) and Free (11): only show Complete button, no amount inputs -->
                <button
                  nz-button
                  nzType="primary"
                  nzSize="large"
                  (click)="saveAndComplete()"
                  [nzLoading]="visitAddFacade.loading()"
                  [disabled]="isBookingDateFuture()"
                >
                  <span nz-icon nzType="check-circle"></span> დასრულება
                </button>
              } @else {
                <button
                  nz-button
                  nzSize="large"
                  (click)="savePayment()"
                  [nzLoading]="visitAddFacade.loading()"
                  [disabled]="isBookingDateFuture()"
                >
                  <span nz-icon nzType="save"></span> შენახვა
                </button>
                @if (canCompleteWithCurrentPayment) {
                  <button
                    nz-button
                    nzType="primary"
                    nzSize="large"
                    (click)="saveAndComplete()"
                    [nzLoading]="visitAddFacade.loading()"
                    [disabled]="isBookingDateFuture()"
                  >
                    <span nz-icon nzType="check-circle"></span> შენახვა და დასრულება
                  </button>
                }
              }
            </div>
          }

          <!-- ==================== FULLY PAID — COMPLETE BUTTON ==================== -->
          @if (visitAddFacade.visit()?.status !== 'COMPLETED' && visitAddFacade.isFullyPaid() && !visitAddFacade.isZeroTotal()) {
            <div class="flex flex-col gap-3 py-2">
              @if (visitAddFacade.totalConsignation() > 0) {
                <nz-alert nzType="warning" [nzMessage]="'თანხა სრულად გადახდილია (კონსიგნაცია: ' + visitAddFacade.totalConsignation() + ' ₾)'" [nzShowIcon]="true"></nz-alert>
              } @else {
                <nz-alert nzType="info" nzMessage="თანხა სრულად გადახდილია" [nzShowIcon]="true"></nz-alert>
              }
              <button
                nz-button
                nzType="primary"
                nzSize="large"
                (click)="completeVisit()"
                [nzLoading]="visitAddFacade.loading()"
              >
                <span nz-icon nzType="check-circle"></span> დასრულება
              </button>
            </div>
          }

          <!-- ==================== COMPLETED STATE ==================== -->
          @if (visitAddFacade.visit()?.status === 'COMPLETED') {
            <div class="flex flex-col gap-3 py-2">
              <h3 class="text-xl font-bold mt-4">
                გადახდის დეტალები
              </h3>
              <div class="flex justify-between items-center gap-3 border-b py-2">
                <div class="text-lg">
                  {{ visitAddFacade.visit().paymentType | paymentType | translate }}
                </div>
                <div class="text-sm text-gray-500">
                  {{ visitAddFacade.visit().paymentDate | date:'medium' }}
                </div>
              </div>

              @if (visitAddFacade.visit()?.cash > 0) {
                <div class="flex justify-between items-center gap-3 py-2">
                  <div>ნაღდი ფული:</div>
                  <div>{{ visitAddFacade.visit()?.cash }} <i class="lari lari-c"></i></div>
                </div>
              }

              @if (visitAddFacade.visit()?.card > 0) {
                <div class="flex justify-between items-center gap-3 py-2">
                  <div>ბარათით გადახდა: ({{ visitAddFacade.visit()?.bank }})</div>
                  <div>{{ visitAddFacade.visit()?.card }} <i class="lari lari-c"></i></div>
                </div>
              }

              @if (visitAddFacade.visit()?.bankTransfer > 0) {
                <div class="flex justify-between items-center gap-3 py-2">
                  <div>ბანკის გადარიცხვა: ({{ visitAddFacade.visit()?.bankTransferBank }})</div>
                  <div>{{ visitAddFacade.visit()?.bankTransfer }} <i class="lari lari-c"></i></div>
                </div>
              }

              @if (visitAddFacade.visit()?.balance > 0) {
                <div class="flex justify-between items-center gap-3 py-2">
                  <div>ბალანსით გადახდა:</div>
                  <div>{{ visitAddFacade.visit()?.balance }} <i class="lari lari-c"></i></div>
                </div>
              }

              @if (visitAddFacade.visit()?.barter > 0) {
                <div class="flex justify-between items-center gap-3 py-2">
                  <div>ბარტერი:</div>
                  <div>{{ visitAddFacade.visit()?.barter }} <i class="lari lari-c"></i></div>
                </div>
              }

              @if (visitAddFacade.visit()?.consignation > 0) {
                <div class="flex justify-between items-center gap-3 py-2">
                  <div>კონსიგნაცია:</div>
                  <div>{{ visitAddFacade.visit()?.consignation }} <i class="lari lari-c"></i></div>
                </div>
              }

              @if (visitAddFacade.visit()?.minutes > 0) {
                <div class="flex justify-between items-center gap-3 py-2">
                  <div>წუთები:</div>
                  <div>{{ visitAddFacade.visit()?.minutes }} წთ</div>
                </div>
              }

              <nz-alert nzType="success" nzMessage="ვიზიტი დასრულდა" [nzShowIcon]="true"></nz-alert>
              <div class="flex justify-end gap-3 py-2">
                <button nz-button nzType="primary" (click)="printReceipt()">
                  <i nz-icon nzType="download"></i>
                  ინვოისის ჩამოტვირთვა
                </button>

                <button nz-button nzType="primary" (click)="sendRecipe()">
                  <i nz-icon nzType="send"></i>
                  ინვოისის გაგზავნა
                </button>
              </div>
              @if (canRevert()) {
                <div class="flex justify-start py-2">
                  <button
                    nz-button
                    nzType="default"
                    [nzDanger]="true"
                    (click)="onRevertClick()"
                    [nzLoading]="revertingCompletion()"
                    [disabled]="revertingCompletion()"
                    *ngxPermissionsOnly="['Admin']"
                  >
                    <span nz-icon nzType="rollback" nzTheme="outline"></span>
                    დასრულებული ვიზიტის დაბრუნება
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </nz-tab>
      }

      @if (visitAddFacade.visitId) {
        <nz-tab
          [nzTitle]="commentsTitle"
        >
          <ng-template #commentsTitle let-visible="visible">
            <div class="px-3 py-0 w-[220px] flex gap-2">
              <div>
                <span nz-icon nzType="comment" nzTheme="outline"></span>
              </div>
              <div>{{ 'visitComments.tabTitle' | translate }}</div>
            </div>
          </ng-template>
          <div class="w-full pr-2 pl-2 lg:pr-6 lg:pl-0 pt-4 pb-6">
            <beautyapp-visit-comments
              [visitId]="+visitAddFacade.visitId"
              [reloadCount]="commentsReloadCount()"
              (commentsChanged)="bookingListReloadCount.set(bookingListReloadCount() + 1)"
            ></beautyapp-visit-comments>
          </div>
        </nz-tab>
      }

      @if (visitAddFacade.visitId) {
        <nz-tab
          [nzTitle]="historyTitle"
        >
          <ng-template #historyTitle let-visible="visible">
            <div class="px-3 py-0 w-[220px] flex gap-2">
              <div>
                <span nz-icon nzType="history" nzTheme="outline"></span>
              </div>
              <div>ისტორია</div>
            </div>
          </ng-template>
          <div class="w-full pr-2 pl-2 lg:pr-6 lg:pl-0 pt-4 pb-6">
            <beautyapp-visit-audit-history
              [visitId]="+visitAddFacade.visitId"
              [reloadCount]="historyReloadCount()"
            ></beautyapp-visit-audit-history>
          </div>
        </nz-tab>
      }

      @if (visitAddFacade.visitId) {
        <nz-tab [nzTitle]="operationsTitle" (nzSelect)="onOperationsTabSelected()">
          <ng-template #operationsTitle let-visible="visible">
            <div class="px-3 py-0 w-[220px] flex gap-2">
              <div>
                <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
              </div>
              <div>ოპერაციები</div>
            </div>
          </ng-template>
          <div class="w-full pr-2 pl-2 lg:pr-6 lg:pl-0 pt-4 pb-6">
            @if (operationsLoading()) {
              <div class="flex justify-center py-4">
                <span nz-icon nzType="loading" nzTheme="outline"></span>
              </div>
            } @else if (operations().length === 0) {
              <div class="py-4 text-center text-gray-500">ამ ვიზიტს ოპერაციები არ აქვს</div>
            } @else {
              <nz-table [nzData]="operations()" [nzShowPagination]="false" [nzSize]="'small'">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>თარიღი</th>
                    <th>თანამშრომელი</th>
                    <th>სერვისები</th>
                    <th>თანხა</th>
                    <th>გადახდის ტიპი</th>
                    <th>სტატუსი</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let op of operations()">
                    <td>{{ op.id }}</td>
                    <td>{{ op.createdAt | date:'yyyy-MM-dd HH:mm' }}</td>
                    <td>{{ op.employee?.user?.fullName }}</td>
                    <td>{{ op.operationDetails?.length || 0 }}</td>
                    <td>{{ op.totalAmount }}</td>
                    <td>{{ paymentTypeLabel(op.paymentType) }}</td>
                    <td>{{ operationStatusLabel(op.status) }}</td>
                    <td>
                      <button
                        nz-button
                        nzType="link"
                        nzSize="small"
                        (click)="onOperationClick(op)"
                        title="დეტალები"
                      >
                        <span nz-icon nzType="eye" nzTheme="outline"></span>
                        დეტალები
                      </button>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
            }
          </div>
        </nz-tab>
      }

    </nz-tabset>
  </div>


  <div class="absolute bottom-0 bg-white w-full border border-t-2 z-10">
    <!-- Mobile view (stacked) -->
    <div class="md:hidden flex flex-col p-2 gap-2">
      <div class="flex justify-between items-center">
        <div class="font-medium flex items-center gap-2">
          სტატუსი:
          @if (visitAddFacade.isCompleted) {
            <span class="text-[#FF3FB4]">{{ visitAddFacade.visit()?.status | visitStatus }}</span>
          } @else {
            <nz-select
              [ngModel]="visitAddFacade.visit()?.status"
              (ngModelChange)="onStatusChange($event)"
              [nzDisabled]="updatingStatus() || !visitAddFacade.visitId"
              [nzLoading]="updatingStatus()"
              nzSize="small"
              style="min-width: 140px;"
              [ngModelOptions]="{standalone: true}"
            >
              @for (opt of statusOptions; track opt.value) {
                <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
              }
            </nz-select>
          }
        </div>
      </div>
      <div class="flex flex-wrap gap-2">
        <div class="rounded-2xl border border-[#FF3FB4] py-1 px-3 text-sm flex-1 h-full">
          წუთები: <span class="text-[#FF3FB4]">{{ visitAddFacade.visit()?.totalBookingMinutes || 0 }} წთ</span>
        </div>
        <div class="rounded-2xl border border-[#FF3FB4] py-1 px-3 text-sm flex-1">
          პროცედურებით: <span class="text-[#FF3FB4]">{{ visitAddFacade.visit()?.totalBookingPayment || 0 }} <i
          class="lari lari-c"></i></span>
        </div>
        <div class="rounded-2xl border border-[#FF3FB4] py-1 px-3 text-sm flex-1">
          პროდუქციით: <span class="text-[#FF3FB4]">{{ visitAddFacade.visit()?.totalRealizationPayment || 0 }} <i
          class="lari lari-c"></i></span>
        </div>
      </div>
    </div>

    <!-- Desktop view (side by side) -->
    <div class="hidden md:flex justify-between items-center p-2 gap-2">
      <div class="flex items-center gap-2">
        სტატუსი:
        @if (visitAddFacade.isCompleted) {
          <span class="text-[#FF3FB4]">{{ visitAddFacade.visit()?.status | visitStatus }}</span>
        } @else {
          <nz-select
            [ngModel]="visitAddFacade.visit()?.status"
            (ngModelChange)="onStatusChange($event)"
            [nzDisabled]="updatingStatus() || !visitAddFacade.visitId"
            [nzLoading]="updatingStatus()"
            nzSize="small"
            style="min-width: 160px;"
            [ngModelOptions]="{standalone: true}"
          >
            @for (opt of statusOptions; track opt.value) {
              <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
            }
          </nz-select>
        }
      </div>
      <div class="flex gap-2 items-center">
        <div class="rounded-2xl border border-[#FF3FB4] py-2 px-4 text-lg">
          წუთები: <span class="text-[#FF3FB4]">{{ visitAddFacade.totalMinutes() || 0 }} წთ</span>
        </div>
        <div class="rounded-2xl border border-[#FF3FB4] py-2 px-4 text-lg">
          პროცედურებით: <span class="text-[#FF3FB4]">{{ visitAddFacade.totalPrice() || 0 }} <i
          class="lari lari-c"></i></span>
        </div>
        <div class="rounded-2xl border border-[#FF3FB4] py-2 px-4 text-lg">
          პროდუქციით: <span class="text-[#FF3FB4]">{{ visitAddFacade.totalRealizationPrice() || 0 }} <i
          class="lari lari-c"></i></span>
        </div>
      </div>
    </div>
  </div>
</div>

